import {
  resolveTrialActivationConfirm,
  useTrialActivationConfirmDialogStore,
} from '@repo/studio-hooks-coins/use-trial-activation-confirm-dialog'
import { TrialActivationConfirmDialog } from './dialog'

/**
 * Mount once inside a router-aware shell (`StudioLayout`). The confirm hook
 * only opens the store; without this host the waiter never paints a dialog.
 */
export function TrialActivationConfirmDialogHost() {
  const isOpen = useTrialActivationConfirmDialogStore(s => s.isOpen)

  return (
    <TrialActivationConfirmDialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) {
          resolveTrialActivationConfirm(false)
        }
      }}
    />
  )
}
